export default {
  badge: 'ផ្លាក',
  open: 'បើក',
  close: 'បិទ',
  dismiss: 'បោះបង់',
  confirmEdit: {
    ok: 'យល់ព្រម',
    cancel: 'បោះបង់',
  },
  dataIterator: {
    noResultsText: 'មិនមានទិន្នន័យដែលត្រូវគ្នាទេ',
    loadingText: 'កំពុងដំណើរការ...',
  },
  dataTable: {
    itemsPerPageText: 'ជ្រើសរើសពត៌មានក្នុងមួយទំព័រ:',
    ariaLabel: {
      sortDescending: 'តំណទំហំចុះរួម។',
      sortAscending: 'តំណទំហំឡើងរួម។',
      sortNone: 'មិនចុះរួម។',
      activateNone: 'ចុចដើម្បីដកតំណទំហំ។',
      activateDescending: 'ចុចដើម្បីតំណទំហំចុះរួម។',
      activateAscending: 'ចុចដើម្បីតំណទំហំឡើងរួម។',
      selectRow: 'ជ្រើសរើសជួរ',
      selectAll: 'ជ្រើសរើសទាំងអស់',
      selectGroup: 'ជ្រើសរើសក្រុម',
    },
    sortBy: 'តម្រៀបតាម',
  },
  dataFooter: {
    itemsPerPageText: 'ទំនិញក្នុងមួយទំព័រ:',
    itemsPerPageAll: 'ទាំងអស់',
    nextPage: 'ទំព័របន្ទាប់',
    prevPage: 'ទំព័រមុន',
    firstPage: 'ទំព័រដំបូង',
    lastPage: 'ទំព័រចុងក្រោយ',
    pageText: '{0}-{1} នៃ {2}',
  },
  dateRangeInput: {
    divider: 'ដល់',
  },
  monthPicker: {
    title: 'ជ្រើសរើសខែ',
    itemsSelected: '{0} ត្រូវបានជ្រើសរើស',
    header: 'បញ្ចូលខែ',
    range: {
      title: 'បញ្ចូលខែ',
    },
    ariaLabel: {
      previousYear: 'ឆ្នាំមុន',
      nextYear: 'ឆ្នាំក្រោយ',
      selectYear: 'Select year',
      currentMonth: 'ខែបច្ចុប្បន្ន, {0}',
    },
  },
  datePicker: {
    itemsSelected: '{0} ត្រូវបានជ្រើសរើស',
    range: {
      title: 'ជ្រើសរើសកាលបរិច្ឆេទ',
      header: 'បញ្ចូលកាលបរិច្ឆេទ',
    },
    title: 'ជ្រើសរើសកាលបរិច្ឆេទ',
    header: 'បញ្ចូលកាលបរិច្ឆេទ',
    input: {
      placeholder: 'បញ្ចូលកាលបរិច្ឆេទ',
    },
    ariaLabel: {
      previousMonth: 'Previous month',
      nextMonth: 'Next month',
      selectYear: 'Select year',
      previousYear: 'ឆ្នាំមុន',
      nextYear: 'ឆ្នាំក្រោយ',
      selectMonth: 'ជ្រើសរើសខែ',
      selectDate: '{0}',
      currentDate: 'Today, {0}',
    },
  },
  noDataText: 'គ្មានទិន្នន័យដែលមាន',
  carousel: {
    prev: 'រុករករូបភាពមុន',
    next: 'រុករករូបភាពបន្ទាប់',
    ariaLabel: {
      delimiter: 'រូបភាពទី {0} នៃ {1} ក្នុងកម្រិតការរុករក',
    },
  },
  calendar: {
    moreEvents: '{0} ទៀត',
    today: 'ថ្ងៃនេះ',
  },
  heatmap: {
    less: 'តិច',
    more: 'ច្រើន',
  },
  input: {
    clear: 'សម្អាត {0}',
    prependAction: '{0} សម្អាតសកម្ម',
    appendAction: '{0} សម្អាតសកម្ម',
    otp: 'សូមបញ្ចូលតួអក្សរ OTP {0}',
  },
  fileInput: {
    counter: '{0} ឯកសារ',
    counterSize: '{0} ឯកសារ ({1} សរុប)',
  },
  fileUpload: {
    title: 'អូសហើយទម្លាក់ឯកសារនៅទីនេះ',
    divider: 'ឬ',
    browse: 'រកមើលឯកសារ',
  },
  timePicker: {
    am: 'ព្រឹក',
    pm: 'ល្ងាច',
    title: 'ជ្រើសរើសម៉ោង',
    hour: 'ម៉ោង',
    minute: 'នាទី',
    second: 'វិនាទី',
    notAllowed: 'តម្លៃមិនត្រូវបានអនុញ្ញាតទេ',
  },
  pagination: {
    ariaLabel: {
      root: 'ការរុករកទំព័រ',
      next: 'ទំព័របន្ទាប់',
      previous: 'ទំព័រមុន',
      page: 'ទៅទំព័រ {0}',
      currentPage: 'ទំព័រ {0}, ទំព័របច្ចុប្បន្ន',
      first: 'ទំព័រដំបូង',
      last: 'ទំព័រចុងក្រោយ',
    },
  },
  stepper: {
    next: 'បន្ទាប់',
    prev: 'មុន',
  },
  rating: {
    ariaLabel: {
      item: 'ការវាយតម្លៃ {0} នៃ {1}',
    },
  },
  loading: 'កំពុងដំណើរការ...',
  infiniteScroll: {
    loadMore: 'ទាញយកបន្ថែម',
    empty: 'គ្មានទំព័រទៀត',
  },
  rules: {
    required: 'វាលនេះត្រូវបានទាមទារ',
    email: 'សូមបញ្ចូលអ៊ីមែលត្រឹមត្រូវ',
    number: 'វាលនេះអាចមានតែលេខប៉ុណ្ណោះ',
    integer: 'វាលនេះអាចមានតែចំនួនគត់ប៉ុណ្ណោះ',
    capital: 'វាលនេះអាចមានតែអក្សរធំប៉ុណ្ណោះ',
    maxLength: 'អ្នកត្រូវបញ្ចូលអតិបរមា {0} តួអក្សរ',
    minLength: 'អ្នកត្រូវបញ្ចូលយ៉ាងហោចណាស់ {0} តួអក្សរ',
    strictLength: 'ប្រវែងនៃវាលដែលបានបញ្ចូលមិនត្រឹមត្រូវទេ',
    exclude: 'តួអក្សរ {0} មិនត្រូវបានអនុញ្ញាតទេ',
    notEmpty: 'សូមជ្រើសរើសយ៉ាងហោចណាស់តម្លៃមួយ',
    pattern: 'ទម្រង់មិនត្រឹមត្រូវ',
  },
  command: {
    search: 'វាយបញ្ចូលពាក្យបញ្ជា ឬស្វាគមន៍...',
  },
  hotkey: {
    then: 'បន្ទាប់មក',
    ctrl: 'Ctrl',
    command: 'Command',
    shift: 'Shift',
    alt: 'Alt',
    option: 'Option',
    enter: 'Enter',
    escape: 'Escape',
    upArrow: 'ព្រួញ​ឡើង​លើ',
    downArrow: 'ព្រួញ​ចុះក្រោម',
    leftArrow: 'ព្រួញ​ឆ្វេង',
    rightArrow: 'ព្រួញ​ស្តាំ',
    backspace: 'Backspace',
    space: 'ដកឃ្លា',
    plus: 'បូក',
    shortcut: 'គ្រាប់ចុចរហ័ស: {0}',
    or: 'ឬ',
  },
  video: {
    play: 'លេង',
    pause: 'ផ្អាក',
    seek: 'ស្វែងរក',
    volume: 'កម្រិតសំឡេង',
    showVolume: 'បង្ហាញការគ្រប់គ្រងកម្រិតសំឡេង',
    mute: 'បិទសំឡេង',
    unmute: 'បើក​សំឡេង',
    enterFullscreen: 'ពេញអេក្រង់',
    exitFullscreen: 'ចេញពីអេក្រង់ពេ',
  },
  colorPicker: {
    ariaLabel: {
      eyedropper: 'ជ្រើសរើសពណ៌ពីអេក្រង់',
      hueSlider: 'ពណ៌',
      alphaSlider: 'អាល់ហ្វា',
      redInput: 'ក្រហម',
      greenInput: 'បៃតង',
      blueInput: 'ខៀវ',
      alphaInput: 'អាល់ហ្វា',
      hueInput: 'ពណ៌',
      saturationInput: 'តិត្ថិភាព',
      lightnessInput: 'ពន្លឺ',
      hexInput: 'តម្លៃ HEX',
      hexaInput: 'HEX ដែលមានតម្លៃអាល់ហ្វា',
      changeFormat: 'ប្ដូរទម្រង់ពណ៌',
    },
  },
}
